import { format } from 'date-fns'
import parseISO from 'date-fns/parseISO'
import parseDate from './parseDate'

const formatDateToMonth = utcDate => {
  try {
    if (!date || date.length === 0) {
      return date
    }
    const date = parseDate(utcDate)
    console.log(date)
    const month = format(date, 'yyyy-LL')

    return month
  } catch(error) {
    console.warn(error)
    throw "date error"
  }
}

export default formatDateToMonth



// WEBPACK FOOTER //
// ./src/utility/formatDateToMonth.js